export default __webpack_public_path__ + "static/ingenieria-civil-industrial-mobile-376b211d5c90dca284dafafa2fb7b775.svg";